import { HttpErrorResponse } from '@angular/common/http';
import { ApiException, ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';
import { QueueElementError } from 'src/core/queue/domain/queue-element';

export class BadRequestException extends ApiException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'BadRequestException';
  }

  static fromError(error: HttpErrorResponse | Error): BadRequestException {
    return new this(error.message, error);
  }

  getErrors(): Array<QueueElementError> {
    if (this.originalError instanceof HttpErrorResponse) {
      return this.originalError?.error?.errors ?? [];
    }

    return [];
  }
}
